import { api } from '../../api';
import { Step } from '../../app/entities/step';
import { entityPool } from '../../core/engine/engine';
import { Stage } from '../../app/entities/stage';
import { Project } from '../../app/entities/project';
import { Asset } from '../../app/entities/asset';
import { View } from '../../app/entities/view';

/**
 * Create a new step
 */
type CreateStepInput = {
  stageId: string;
  name: string;
  startDate?: string;
  dueDate?: string;
  type: string;
};

export const createStep = async ({ stageId, ...input }: CreateStepInput) => {
  const { data } = await api.post(`/stages/${stageId}/steps`, input);
  entityPool.insert(Object.assign(new Step(), { ...data, stageId }));

  const stage = Stage.getOne(stageId);

  if (!stage) {
    return;
  }

  const project = Project.getOne(stage.projectId);
  if (project) {
    project.progress = data.progress;
  }

  if (data.view) {
    const view = Object.assign(new View(), data.view);
    entityPool.insert(view);
  }

  if (data.strip) {
    const stripboard = project?.stripboard;

    if (stripboard) {
      stripboard.addStrip(data.strip);
      stage.reorderShootingDays();
      stripboard.reorderShootingDaysStrips(stage.steps);
    }
  }

  /**
   * Get folder
   */
  if (data.folderAssetId) {
    const { data: folderData } = await api.get(`/assets/${data.folderAssetId}`);
    const folder = Object.assign(new Asset(), folderData);
    entityPool.insert(folder);
  }

  return data;
};
